import type { BillingPlan } from '@core/products-types';

import { getProduct } from './get-product';
import type { PricingFeatureLoadedModel } from '../types/pricing-feature.types';

export class ActiveProductCodenameNotFoundError extends Error {
  public name = 'ActiveProductCodenameNotFoundError';
  constructor() {
    super();
    Object.setPrototypeOf(this, ActiveProductCodenameNotFoundError.prototype);
  }
}

export const getActiveProductOrThrow = (
  {
    currency,
    subscription,
    trial,
  }: Pick<PricingFeatureLoadedModel, 'currency' | 'subscription' | 'trial'>,
  products: BillingPlan[] | undefined,
  activeBillingPlan?: BillingPlan,
): BillingPlan => {
  if (activeBillingPlan) {
    return activeBillingPlan;
  } else if (trial?.productCode) {
    return getProduct(trial.productCode, currency, products, true)!;
  } else {
    throw new ActiveProductCodenameNotFoundError();
  }
};
